import React from "react";
import ErrorFallback from "./ErrorFallback";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });

    // Log raw error first so circular-reference / non-Error objects are visible in console
    console.error("[ErrorBoundary] RAW error object:", error);
    try {
      console.error("[ErrorBoundary] stringified:", JSON.stringify(error, null, 2));
    } catch (_) {
      console.error("[ErrorBoundary] (error is not JSON-serialisable — likely circular reference or React internal)");
    }
    console.error("[ErrorBoundary] componentStack:", errorInfo?.componentStack);
    console.error("[ErrorBoundary] metadata", {
      message: error?.message,
      stack: error?.stack,
      location: window.location.pathname,
      timestamp: new Date().toISOString(),
    });

    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }

  reset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      // Allow callers to provide a custom fallback (or null to render nothing)
      if ('fallback' in this.props) {
        return this.props.fallback ?? null;
      }
      return (
        <ErrorFallback
          error={this.state.error}
          errorInfo={this.state.errorInfo}
          onReset={this.reset}
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
